import { APIClient } from "api/api_helper";
import { SUBJECTDETAILS_API, SESSION_API } from "api/url_helper";
import {
  SubjectDetailsResponse,
  AddDeviationReasonPayload,
  DeviationReasonResponseData,
  ApiResponse,
  ScanSheetResponseData,
} from "modules/Clinical/TimePoints/helpers/timpoints.types";

const api = new APIClient();

export const subjectDetailsApiService = {


    // -----------------------------
    // SELECT ALL
    // -----------------------------
    getSelectAllData: (
        studyid?: number | null,
        subjectno?: string | null,

    ): Promise<SubjectDetailsResponse> => {
        const payload = {
            studyid: studyid ?? null,
            subjectno: subjectno ?? null,
         
        };

        return api.create(
            SUBJECTDETAILS_API.SUBJECT_PERIOD_INFO_API + "Select",
            payload
        );
    },

    getSelectData: (
        studyid?:     number | null,
        volunteerid?: number | null,
    ): Promise<SubjectDetailsResponse> => {
        const payload = {
            studyid:     studyid     ?? null,
            volunteerid: volunteerid ?? null,
        };
 
        return api.create(
            SUBJECTDETAILS_API.SUBJECTDETAILS_API + "Select",
            payload
        );
    },

    updateActualCollectionTimes: (
        payload: FormData
    ): Promise<any> => {
        return api.create(
            SUBJECTDETAILS_API.SUBJECT_PERIOD_INFO_API + "ActualSampleCollectionTime/Update",
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    },

    correctSingleCollectionTime: (payload: {
        samplecollectionid: number;
        samplecollectiontime: string;
        updatedby: number;
        updatereason: string;
    }): Promise<any> => {
        return api.create(
            SUBJECTDETAILS_API.SUBJECT_PERIOD_INFO_API + "ActualSampleCollectionTime/Correct",
            payload
        );
    },
    addDeviationReason: (
        payload: AddDeviationReasonPayload
    ): Promise<ApiResponse<DeviationReasonResponseData>> => {
        return api.create(
            SUBJECTDETAILS_API.SUBJECT_PERIOD_INFO_API + "DeviationReason/Update",
            payload
        );
    },


    scanSheet: (
        payload: FormData
    ): Promise<ApiResponse<ScanSheetResponseData>> => {
        return api.create(
            SUBJECTDETAILS_API.SUBJECT_PERIOD_INFO_API + "ActualSampleCollectionTime/ScanSheet",
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    },

    verifySampleCollectionTimeGlobal: (payload: {
        studyid: number;
        subjectno: string;
        periodid: number;
        verifiedby: number;
        verifypin: string;
    }): Promise<any> => {
        return api.create(
            SESSION_API.SAMPLE_COLLECTION_TIME_API + "GlobalVerify",
            payload
        );
    },
};
